import { Typography } from '@material-ui/core'

import adotelHome from '../../assets/images/adotelHome.svg'
import {
  getNameFromStorage,
  getRoleLabelFromStorage
} from '../../helpers/userData'
import { getTranslate } from '../../localization'
import useStyles from './styles/header.styles'

export default function Header() {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <img src={adotelHome} />
      <div>
        <Typography className={classes.title}>
          {`${getTranslate('Wellcome Back')} ${getNameFromStorage()} `}
        </Typography>
        <Typography className={classes.subTitle}>
          {`${getTranslate('Role')}: ${getRoleLabelFromStorage()} `}
        </Typography>
      </div>
    </div>
  )
}
